module.exports = __webpack_public_path__ + "img/crown.008762f7.svg";